import { useEventConfig } from '@/eventConfig/useEventConfig.ts';
import { translate } from '@/translation/translate.ts';
import { EditDataField } from '@/components/slides/DataSummary/components/EditDataField.tsx';
import { addReqiredMessage } from '@/components/slides/DataSummary/util/addRequiredMessage.ts';
import { useSummaryFormField } from '@/components/slides/DataSummary/components/useSummaryFormField.ts';
import { EditSaveButtons } from '@/components/slides/DataSummary/components/EditSaveButtons.tsx';
import { useForm } from '@/form/useForm.ts';

export const AddressSummaryFormIN = () => {
  const { onStartEdit, onCancelEdit, onSave, editMode, isValid } = useSummaryFormField({ slideIds: ['address'] });

  const { getFieldValue } = useForm();

  const { eventConfig } = useEventConfig();
  const s = eventConfig!.slides;

  // Fields apartment, houseno, roadName, locality,  town, pincode, landmark,county, state
  const apartmentNoField = s.address.fields.find(({ name }) => name === 'apartment');
  const apartmentNoLabel = translate(apartmentNoField?.label);

  const housenoField = addReqiredMessage({
    field: s.address.fields.find(({ name }) => name === 'houseno'),
    message: s.dataSummary.requiredMessage!,
  });
  const housenoLabel = translate(housenoField?.label);

  const roadNameField = addReqiredMessage({
    field: s.address.fields.find(({ name }) => name === 'roadName'),
    message: s.dataSummary.requiredMessage!,
  });
  const roadNameLabel = translate(roadNameField?.label);

  const localityField = addReqiredMessage({
    field: s.address.fields.find(({ name }) => name === 'locality'),
    message: s.dataSummary.requiredMessage!,
  });
  const localityLabel = translate(localityField?.label);

  const townField = addReqiredMessage({
    field: s.address.fields.find(({ name }) => name === 'town'),
    message: s.dataSummary.requiredMessage!,
  });
  const townLabel = translate(townField?.label);

  const pincodeField = addReqiredMessage({
    field: s.address.fields.find(({ name }) => name === 'pincode'),
    message: s.dataSummary.requiredMessage!,
  });
  const pincodeLabel = translate(pincodeField?.label);

  const landmarkField = s.address.fields.find(({ name }) => name === 'landmark');
  const landmarkLabel = translate(landmarkField?.label);

  const districtField = s.address.fields.find(({ name }) => name === 'county');
  const districtLabel = translate(districtField?.label);

  const stateField = addReqiredMessage({
    field: s.address.fields.find(({ name }) => name === 'state'),
    message: s.dataSummary.requiredMessage!,
  });
  const stateLabel = translate(stateField?.label);
  const stateValue =
    translate(stateField?.options?.find(({ value }) => value == getFieldValue('state'))?.label) ||
    getFieldValue('state');

  // apartment, houseno, roadName, locality,  town, pincode, landmark,county, state
  return (
    <div className="summary-card" data-cy={'summary-form-address'}>
      <h2>{translate(s.dataSummary.titles?.address)}</h2>
      <EditSaveButtons
        editMode={editMode}
        onSave={onSave}
        onStartEdit={onStartEdit}
        onCancelEdit={onCancelEdit}
        isValid={isValid}
      />

      <div className="data">
        <div className={'label'}>{apartmentNoLabel}</div>
        <div className={'value'}>
          {!editMode && getFieldValue('apartment')}
          {editMode && <EditDataField field={apartmentNoField!} slideId={'address'} />}
        </div>

        <div className={'label'}>{housenoLabel}</div>
        <div className={'value'}>
          {!editMode && getFieldValue('houseno')}
          {editMode && <EditDataField field={housenoField!} slideId={'address'} />}
        </div>

        <div className={'label'}>{roadNameLabel}</div>
        <div className={'value'}>
          {!editMode && getFieldValue('roadName')}
          {editMode && <EditDataField field={roadNameField!} slideId={'address'} />}
        </div>

        <div className={'label'}>{localityLabel}</div>
        <div className={'value'}>
          {!editMode && getFieldValue('locality')}
          {editMode && <EditDataField field={localityField!} slideId={'address'} />}
        </div>

        <div className={'label'}>{townLabel}</div>
        <div className={'value'}>
          {!editMode && getFieldValue('town')}
          {editMode && <EditDataField field={townField!} slideId={'address'} />}
        </div>

        <div className={'label'}>{pincodeLabel}</div>
        <div className={'value'}>
          {!editMode && getFieldValue('pincode')}
          {editMode && <EditDataField field={pincodeField!} slideId={'address'} />}
        </div>

        <div className={'label'}>{landmarkLabel}</div>
        <div className={'value'}>
          {!editMode && getFieldValue('landmark')}
          {editMode && <EditDataField field={landmarkField!} slideId={'address'} />}
        </div>

        <div className={'label'}>{districtLabel}</div>
        <div className={'value'}>
          {!editMode && getFieldValue('county')}
          {editMode && <EditDataField field={districtField!} slideId={'address'} />}
        </div>

        <div className={'label'}>{stateLabel}</div>
        <div className={'value'}>
          {!editMode && stateValue}
          {editMode && <EditDataField field={stateField!} slideId={'address'} />}
        </div>
      </div>
    </div>
  );
};
